import React from 'react'
import { i18nTranslate } from 'src/utils'
import { observer } from 'mobx-react'
import { customerContainer } from 'src/models'
import { Button, Card } from 'react-bootstrap'
import { MdLock as SecurityIcon } from 'react-icons/md'
import { MetaDecorator } from 'src/views/components'
import { APPConfig } from 'config/appConfig'
import './styles.scss'

@observer
class Security extends React.Component {
  constructor(props) {
    super(props)
  }

  /**
   * @todo
   * Below mentioned okta profile URl needs to be moved to defaultConfig.json
   */

  handleChangePassword = async () => {
    await customerContainer.logout()
    const { oktaDomain } = APPConfig.getAppConfig()
    if (typeof window !== 'undefined') {
      window.location.replace(`${oktaDomain}/signin/forgot-password`)
    }
  }
  render() {
    const myAccountSecurityTitle = i18nTranslate(
      'myAccountSecurityPage.title',
      'Security | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountSecurityTitle}
          imageUrl=""
          imageAlt=""
          description="My Account Security Page"
          location={this.props}
        />
        <div className="account-wrapper">
          <Card className="mb-2 shadow-sm">
            <Card.Body className="px-2 px-md-3">
              <Card.Title>
                <h1 className="card-title heading-2">
                  <SecurityIcon />
                  <span
                    className="ml-1 pb-1 pl-2"
                    data-testid="qa-security-reset-password">
                    {i18nTranslate('resetPassword.submit', 'Reset Password')}
                  </span>
                </h1>
              </Card.Title>
              <Card.Text>
                {i18nTranslate(
                  'resetPasswordInfo',
                  `In order to reset the password, please click on the below change password button and you will be logged out of the application and will be redirected to Okta profile page in which you can reset your password. Once password reset is done, kindly login again in order to continue shopping.`
                )}
              </Card.Text>
              <Button
                variant="primary"
                onClick={this.handleChangePassword}
                data-testid="qa-change-password"
                className="change-password-button">
                {i18nTranslate('account.changePassword', 'Change Password')}
              </Button>
            </Card.Body>
          </Card>
        </div>
      </>
    )
  }
}

export { Security }

export default Security
